import styled from 'styled-components'

const FretLabels = styled.div`
  display: flex;
  width: ${props => props.width}%;
`

/** @component */
export default FretLabels
